import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file MutationHandler
 * @author yuzong(yuzong@tencent.com)
 */
export var MutationHandler = /*#__PURE__*/function () {
  function MutationHandler() {
    _classCallCheck(this, MutationHandler);

    this.timer = null;
    this.unbindFns = {};
    this.callbackList = [];
    this.state = {
      mutation: false,
      animation: false,
      transition: false,
      scroll: false,
      resize: false
    };
    this.listenedState = {
      mutation: false,
      animation: false,
      transition: false,
      scroll: false,
      resize: false
    };
  }

  _createClass(MutationHandler, [{
    key: "listen",
    value: function listen() {
      var newState = {
        mutation: false,
        animation: false,
        transition: false,
        scroll: false,
        resize: false
      };
      this.callbackList.forEach(function (listener) {
        MutationHandler.MUTATION_STATE_KEYS.forEach(function (key) {
          if (listener[key]) {
            newState[key] = true;
          }
        });
      });
      this.processMutation(this.state.mutation, newState.mutation);
      this.processTransition(this.state.transition, newState.transition);
      this.processScroll(this.state.scroll, newState.scroll);
      this.processAnimation(this.state.animation, newState.animation);
      this.processResize(this.state.resize, newState.resize);
      this.state = newState;
    }
  }, {
    key: "process",
    value: function process(type) {
      var _this = this;

      this.listenedState[type] = true;

      if (this.timer != null) {
        return;
      }

      this.timer = requestAnimationFrame(function () {
        _this.timer = null;

        _this.dispatch();
      });
    }
  }, {
    key: "addListener",
    value: function addListener(callback, options) {
      if (this.callbackList.some(function (item) {
        return item.listener === callback;
      })) {
        throw new Error('function must be bind once');
      }

      this.callbackList.push(_objectSpread(_objectSpread({}, options), {}, {
        listener: callback
      }));
      this.listen();
    }
  }, {
    key: "removeListener",
    value: function removeListener(callback) {
      var index = this.callbackList.findIndex(function (item) {
        return item.listener === callback;
      });

      if (index < 0) {
        return;
      }

      this.callbackList.splice(index, 1);
      this.listen();
    }
  }, {
    key: "dispatch",
    value: function dispatch() {
      var state = this.listenedState;
      var callbackList = this.callbackList.filter(function (item) {
        return MutationHandler.MUTATION_STATE_KEYS.some(function (key) {
          return item[key] && state[key];
        });
      });
      this.listenedState = {
        mutation: false,
        animation: false,
        transition: false,
        scroll: false,
        resize: false
      };
      callbackList.forEach(function (item) {
        return item.listener();
      });
    } // 属性变化

  }, {
    key: "processMutation",
    value: function processMutation(oldState, newState) {
      var _this2 = this;

      if (oldState === newState) {
        return;
      }

      if (newState) {
        var ob = new MutationObserver(function () {
          return _this2.process('mutation');
        });
        ob.observe(document, {
          attributes: true,
          characterData: true,
          childList: true,
          subtree: true
        });

        this.unbindFns.mutation = function () {
          return ob.disconnect();
        };

        return;
      }

      this.unbindFns.mutation && this.unbindFns.mutation();
      this.unbindFns.mutation = undefined;
    } // 渐变动画

  }, {
    key: "processTransition",
    value: function processTransition(oldState, newState) {
      var _this3 = this;

      if (oldState === newState) {
        return;
      }

      if (newState) {
        var event = 'ontransitionend' in document ? 'transitionend' : 'webkitTransitionEnd';

        var callback = function callback() {
          return _this3.process('transition');
        };

        var options = {
          capture: true,
          passive: true
        };
        document.addEventListener(event, callback, options);

        this.unbindFns.transition = function () {
          document.removeEventListener(event, callback, options);
        };

        return;
      }

      this.unbindFns.transition && this.unbindFns.transition();
      this.unbindFns.transition = undefined;
    } // 逐帧动画

  }, {
    key: "processAnimation",
    value: function processAnimation(oldState, newState) {
      var _this4 = this;

      if (oldState === newState) {
        return;
      }

      if (newState) {
        var event = 'onanimationend' in document ? 'animationend' : 'webkitAnimationEnd';

        var callback = function callback() {
          return _this4.process('animation');
        };

        var options = {
          capture: true,
          passive: true
        };
        document.addEventListener(event, callback, options);

        this.unbindFns.animation = function () {
          document.removeEventListener(event, callback, options);
        };

        return;
      }

      this.unbindFns.animation && this.unbindFns.animation();
      this.unbindFns.animation = undefined;
    } // 元素滚动

  }, {
    key: "processScroll",
    value: function processScroll(oldState, newState) {
      var _this5 = this;

      if (oldState === newState) {
        return;
      }

      if (newState) {
        var callback = function callback() {
          return _this5.process('scroll');
        };

        var options = {
          capture: true,
          passive: true
        };
        document.addEventListener('scroll', callback, options);

        this.unbindFns.scroll = function () {
          document.removeEventListener('scroll', callback, options);
        };

        return;
      }

      this.unbindFns.scroll && this.unbindFns.scroll();
      this.unbindFns.scroll = undefined;
    } // 窗体大小变化

  }, {
    key: "processResize",
    value: function processResize(oldState, newState) {
      var _this6 = this;

      if (oldState === newState) {
        return;
      }

      if (newState) {
        var callback = function callback() {
          return _this6.process('resize');
        };

        var options = {
          capture: true,
          passive: true
        };
        window.addEventListener('resize', callback, options);

        this.unbindFns.resize = function () {
          window.removeEventListener('resize', callback, options);
        };

        return;
      }

      this.unbindFns.resize && this.unbindFns.resize();
      this.unbindFns.resize = undefined;
    }
  }], [{
    key: "addMutationHandler",
    value: function addMutationHandler(callback, options) {
      var _options$mutation = options.mutation,
          mutation = _options$mutation === void 0 ? false : _options$mutation,
          _options$animation = options.animation,
          animation = _options$animation === void 0 ? false : _options$animation,
          _options$transition = options.transition,
          transition = _options$transition === void 0 ? false : _options$transition,
          _options$scroll = options.scroll,
          scroll = _options$scroll === void 0 ? false : _options$scroll,
          _options$resize = options.resize,
          resize = _options$resize === void 0 ? false : _options$resize;
      var handler = MutationHandler.MUTATION_HANDLER = MutationHandler.MUTATION_HANDLER || new MutationHandler();
      handler.addListener(callback, _objectSpread({
        mutation: mutation,
        animation: animation,
        transition: transition,
        scroll: scroll,
        resize: resize
      }, options));
    }
  }, {
    key: "removeMutationHandler",
    value: function removeMutationHandler(callback) {
      var handler = MutationHandler.MUTATION_HANDLER = MutationHandler.MUTATION_HANDLER || new MutationHandler();
      handler.removeListener(callback);
    }
  }]);

  return MutationHandler;
}();
MutationHandler.MUTATION_STATE_KEYS = ['mutation', 'animation', 'transition', 'scroll', 'resize'];
MutationHandler.MUTATION_HANDLER = null;